/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Obscuring_Game_StateInputs */



/**
* | output |
* | --- |
* | "Obscuring Game State" |
*
* @param {Sanction_Sub_Obscuring_Game_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_obscuring_game_state = /** @type {((inputs?: Sanction_Sub_Obscuring_Game_StateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Obscuring_Game_StateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dissimulation de l'État de Jeu")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ocultación del Estado de Juego")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ocultação do Estado de Jogo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Occultamento dello Stato di Gioco")
	return /** @type {LocalizedString} */ ("Obscuring Game State")
});